import { Controller } from "@hotwired/stimulus"

// Cloudflare Turnstile in front of a guest's repeat exam start (the
// guest_exam_repeat experiment, Courses::GuestExamsController). Renders the
// widget inline as soon as the page connects and, once Turnstile hands over a
// token, submits the form; #create verifies the token and starts the attempt.
// After a failed check the page comes back with autoSubmit off, so a token that
// keeps failing server-side cannot loop the form: the button submits instead.
export default class extends Controller {
  static targets = ["container", "token", "error", "submit"]
  static values = { sitekey: String, autoSubmit: { type: Boolean, default: true } }

  connect() {
    this.widgetId = null
    this.submitted = false
    this.waitForTurnstile()
  }

  disconnect() {
    clearTimeout(this.timer)
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.remove(this.widgetId)
    }
    this.widgetId = null
  }

  // The api.js script loads async; give it 10 s (blocked or offline otherwise).
  waitForTurnstile(attempts = 0) {
    if (window.turnstile) {
      this.renderWidget()
    } else if (attempts >= 100) {
      this.showError()
    } else {
      this.timer = setTimeout(() => this.waitForTurnstile(attempts + 1), 100)
    }
  }

  renderWidget() {
    try {
      this.widgetId = window.turnstile.render(this.containerTarget, {
        sitekey: this.sitekeyValue,
        callback: (token) => this.verified(token),
        "error-callback": () => this.showError(),
        "expired-callback": () => this.expired()
      })
    } catch (error) {
      this.showError()
    }
  }

  verified(token) {
    this.tokenTarget.value = token
    this.submitTarget.disabled = false
    if (this.autoSubmitValue) this.submit()
  }

  expired() {
    this.tokenTarget.value = ""
    this.submitTarget.disabled = true
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.reset(this.widgetId)
    }
  }

  // The form's submit action too: one submission per page, and never without a
  // token. The native submit() fires no submit event, so this runs once.
  submit(event) {
    event?.preventDefault()
    if (this.submitted || !this.tokenTarget.value) return

    this.submitted = true
    this.submitTarget.disabled = true
    this.element.submit()
  }

  showError() {
    this.errorTarget.hidden = false
  }
}
